/* eslint-disable @angular-eslint/component-selector */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, Input, OnChanges, OnInit, SimpleChanges, forwardRef } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
  Validators,
} from '@angular/forms';
import {
  PaymentFormFieldConfig,
  PaymentFormFieldHooks,
  PaymentFormFieldOptions,
} from '@backbase/initiate-payment-journey-ang';
import { registerFormControl, triggerHook } from '../../utils/helpers/hooks-helpers';
import { NUMERIC_REGEX } from '../../utils/constants/beneficiary-manager.constants';
import { ErrorMessage } from '../../utils/models/shared.model';

@Component({
  selector: 'sbk-phone-number-input',
  templateUrl: './sbk-phone-number-input.component.html',
  styleUrls: ['./sbk-phone-number-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SbkPhoneNumberInputComponent),
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: forwardRef(() => SbkPhoneNumberInputComponent),
    },
  ],
})
export class SbkPhoneNumberInputComponent implements OnInit, OnChanges, ControlValueAccessor, Validator {
  @Input() label = '';
  @Input() maxLength = 30;
  @Input() minLength = 0;
  @Input() showHelpText = false;
  @Input() required = false;
  @Input() isSubmitted = false;
  @Input() helpText = '';
  @Input() isFromMobileBeneficiary = false;
  validationMessages: Array<ErrorMessage> = [];

  config!: PaymentFormFieldConfig;
  group!: FormGroup;
  options!: PaymentFormFieldOptions;
  control!: AbstractControl;
  disabled = false;
  onChanged: (value: string | null) => void = () => { };
  onTouched: () => void = () => { };
  onValidationChange: () => void = () => { };

  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.isSubmitted.currentValue) {
      this.control.markAsTouched();
    }
  }
  ngOnInit(): void {
    if (this.config && this.options) {
      this.control = registerFormControl(
        this.group,
        this.config?.name,
        this.options.validators,
        this.options.asyncValidators,
        this.options.defaultValue,
        this.config,
      );
      triggerHook(PaymentFormFieldHooks.onInit, this);
    } else {
      this.control = new FormControl('');
      if (this.required) {
        this.control.setValidators([Validators.required]);
      }
      if (this.isFromMobileBeneficiary) {
        this.control.setValidators([
          Validators.maxLength(9),
          Validators.minLength(9),
          Validators.pattern(NUMERIC_REGEX),
        ]);
        this.validationMessages = [
          {
            name: 'minlength',
            message: 'Invalid number. Please input a Kenyan 9-digit phone number, such as 703 123 456',
          },
          {
            name: 'maxlength',
            message: 'Invalid number. Please input a Kenyan 9-digit phone number, such as 703 123 456',
          },
          { name: 'pattern', message: 'Invalid format. Please add a Kenyan phone number, such as 703 123 456' },
        ];
      }
    }
    this.onControlValueChange();
  }

  private onControlValueChange() {
    this.control.valueChanges.subscribe((val) => {
      this.onChanged(val);
      this.onValidationChange();
    });
  }

  writeValue(value: string): void {
    this.control.setValue(value);
  }
  registerOnChange(fn: (value: string | null) => void): void {
    this.onChanged = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChange = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    if (isDisabled) {
      this.control?.disable({ emitEvent: false });
      return;
    }
    this.control?.enable({ emitEvent: false });
  }

  validate(): ValidationErrors | null {
    if (this.control?.invalid) {
      return { invalid: true };
    } else {
      return null;
    }
  }

  isDisabled(): boolean {
    return this.disabled || this.control?.disabled || this.options?.disabled;
  }

  isNonEditable(): boolean {
    return this.isDisabled();
  }
}
